exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".c-operation-errors_pagination-wrapper{display:flex;justify-content:flex-end}.c-operation-errors_pagination-wrapper .c-page-selection-component{margin-top:0;margin-right:10px}.c-operation-errors .c-item-disabled{opacity:.3}.c-operation-errors .ReactTable>.rt-table>.rt-tbody .rt-tr>.rt-td{padding-left:5px}.c-operation-errors .ReactTable>.rt-table>.rt-tbody .rt-tr>.rt-td:last-child{justify-content:flex-start}", ""]);

// exports
